module.exports = __webpack_public_path__ + "static/media/lgassegurouwhite.59919833.svg";